import React, { Component } from "react";
import { withRouter } from "../../../utils/router";
import Form from "./Form";
import { auth } from "../../../utils/auth";
import { formatDate, toast } from "../../../utils/helpers";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import { postRequest, withRequest } from "../../../utils/request";
import Modal from "../../general/Modal";
import SearchCedula from "./SearchCedula";

class EditModal extends Component {
    state = {
        errors: {},
        tutor: {},
        showDelete: false,
        saving: false,
        showSearch: false,
        search: "",
        searchResults: null,
        searchSuccess: null,
        searching: false,
    };
    componentDidMount() {
        this.getTutor();
    }
    getTutor = async (url = null) => {
        const id = this.props.id;
        url = url ? url : "academico/padres-tutores/" + id;
        const tutor = await this.props.request(url);

        if (tutor.success) {
            this.setState({
                tutor: tutor.data,
                loading: false,
            });
        }
    };
    updateTutor = async (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        const data = new FormData(event.target);

        const id = this.props.id;
        const url = "academico/padres-tutores/" + id;

        const response = await postRequest(apiUrl(url), data);

        if (response.code === 422) {
            this.setState({ errors: response.data.message, saving: false });
            toast("Tutor no pudo ser actualizado.", "error");
            return;
        }

        if (response.success) {
            this.props.toggleModal('EditTutor', response.data, '');
            toast("Tutor actualizado correctamente.");
        } else {
            toast("Tutor no pudo ser actualizado.", "error");
        }

        this.setState({ saving: false });
    };
    buscarTutor = async (e) => {
        e.preventDefault();

        this.setState({
            searching: true,
        });

        const { search } = this.state;
        const url = `https://app.migente.com.do/api/getpadronexterno/?cedula=${search}&user=felipe_api&pswd=F3l1pe`;
        const response = await fetch(url);
        response.json().then((res) => {
            this.setState({
                searchResults: res.Persona,
                searchSuccess: res.Existe,
                searching: false,
            });
        });
    };
    insertarTutor = () => {
        const search = this.state.searchResults;

        if (!search) {
            return;
        }

        this.setState(prevState => {
            return {tutor: {
                ...prevState.tutor,
                nombre: search.Nombres,
                apellido:
                    search.Apellido1 +
                    " " +
                    (search.Apellido2 ? search.Apellido2 : ""),
                cedula: search.Cedula,
                fechaNacimiento: formatDate(Date.parse(search.FechaNacimiento)),
                direccion: search.Municipio + ", " + search.Provincia,
                foto: search.Imagen,
                fotoCed: search.Imagen,
                nacionalidad: "Dominicano",
            }}
        });
        this.toggleSearchModal();
    };
    toggleSearchModal = () => {
        this.setState({
            showSearch: !this.state.showSearch,
        });
    };
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    render() {
        const {
            errors,
            tipos,
            saving,
            tutor,
            searchResults,
            searching,
            searchSuccess
        } = this.state;

        return (
            <div>
                <form
                    method='post'
                    onSubmit={this.updateTutor}
                    encType='multipart/form-data'>
                    <div className='popup__header'>Editar Padre/Tutor</div>
                    <div className="popup__body">
                        <input type='hidden' name='_method' value='patch' />
                        <Form tutor={tutor} errors={errors} tipos={tipos} toggleSearchModal={this.toggleSearchModal} />
                    </div>
                    <div className='popup__footer'>
                        <button
                            type='button'
                            onClick={() => this.props.toggleModal('EditTutor')}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        {saving ? (
                            <Loader type='small' />
                        ) : (
                            <button type='submit' className='btn btn-primary'>
                                Guardar
                            </button>
                        )}
                    </div>
                </form>
                <Modal
                    blank
                    show={this.state.showSearch}
                    toggle={this.toggleSearchModal}>
                    <SearchCedula
                        searching={searching}
                        searchResults={searchResults}
                        searchSuccess={searchSuccess}
                        onInputChange={this.onInputChange}
                        buscarTutor={this.buscarTutor}
                        insertarTutor={this.insertarTutor}
                        toggleSearchModal={this.toggleSearchModal}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(EditModal));
